import service from '@/plugin/axios.js';
import moment from 'moment';
import md5 from 'js-md5';
import { HSUPLOAD_HOST } from "../constants/apiHosts";

// 对象存储域名
const OSSURL = getPath(window.location.href) === 'topnews.cn' || getPath(window.location.href) === 'topnews.cn' ? `https://img.dingxinwen.cn` : `https://img.dingnews.net`
// 视频点播封面图域名
const VODOSSURL = getPath(window.location.href) === 'topnews.cn' || getPath(window.location.href) === 'topnews.cn' ? `https://vodcover.dingxinwen.cn` : `https://vodcover.dingnews.net`
// 视频URL地址
const VODVIDEOURL = getPath(window.location.href) === 'topnews.cn' || getPath(window.location.href) === 'topnews.cn' ? `https://dvod.dingxinwen.cn` : `https://dvod.dingnews.net`
/**
 * 获取文件扩展名
 *
 * @param file 文件对象
 * @returns 返回文件扩展名（小写形式），如果没有扩展名则返回空字符串
 */
function getFileExtension(file) {
    // 获取文件的完整名称
    const fileName = file.name;
    // 使用lastIndexOf方法查找最后一个'.'的位置
    const lastIndex = fileName.lastIndexOf('.');
    // 如果'.'存在且不是文件名的第一个字符（即存在扩展名）
    if (lastIndex > 0) {
        // 提取'.'之后的所有字符作为扩展名
        return fileName.substring(lastIndex + 1).toLowerCase();
    } else {
        // 如果没有找到'.'或'.'是文件名的第一个字符，则没有扩展名
        return '';
    }
}


class huoshanUploadVideo {
    constructor(options) {
        this.files = []
    }
    /**
     * 上传文件
     *
     * @param {File} file - 要上传的文件
     * @param {Function} completeFun - 上传完成后的回调函数
     * @param {Function} progressFun - 上传进度回调函数
     * @param {Function} errorFun - 上传错误回调函数
     */
    uploadFile(file, completeFun, progressFun, errorFun, isShortPlay) {
        service({
            //url: HSUPLOAD_HOST + (isShortPlay == 1 ? "/api/upload/vod/encryptToken" : "/api/upload/vod/token"),
            url: HSUPLOAD_HOST + "/api/upload/vod/token",
        }).then(res => {
            this.stsToken = {}
            this.stsToken.AccessKeyID = res.data.data.accessKeyId
            this.stsToken.SecretAccessKey = res.data.data.secretAccessKey
            this.stsToken.SessionToken = res.data.data.sessionToken
            this.spaceName = res.data.data.spaceName
            this.uploader = new TTUploader({
                userId: 'dd-admin', // 建议设置能识别用户的唯一标识 ID，用于上传出错时排查问题，不要传入非 ASCII 编码
                appId: '636625', // 在视频点播-应用服务中创建的 AppID，视频点播的质量监控等都是以这个参数来区分业务方的，务必正确填写
                // 仅视频/普通文件上传时需要配置
                videoConfig: {
                    spaceName: this.spaceName,
                }
            });
            let timestamp = new Date().getTime()
            let fileName = `${moment().format('YYYYMMDD')}/${md5(timestamp.toString())}.${getFileExtension(file)}`
            const fileKey = this.uploader.addFile({
                file: file,
                stsToken: this.stsToken, //从服务端拿到的 token，见下方说明
                type: 'video', // 上传文件类型，四个可选值：video(视频或者音频，默认值)，image(图片)，object（普通文件，例如字幕），media（素材文件）
                fileName: `video/${fileName}`,
                processAction: [
                    {
                        Name: 'StartWorkflow',
                        Input: {
                            TemplateId: res.data.data.transcodeFLowId
                        }
                    },
                    {
                        Name: 'AddOptionInfo',
                        Input: {
                            Title: file.name
                        }
                    }
                ]
            });
            this.uploader.start(fileKey);
            this.uploader.on('complete', (infor) => {
                infor.uploadResult.PosterUri = `${VODOSSURL}/${infor.uploadResult.PosterUri}~tplv-vod-noop.image`
                infor.uploadResult.videoUri = `${VODVIDEOURL}/video/${moment().format('YYYYMMDD')}/${infor.uploadResult.Vid}.mp4`
                completeFun(infor.uploadResult)
            });
            this.uploader.on('progress', (infor) => {
                progressFun(infor.percent)
            });
            this.uploader.on('error', (infor) => {
                errorFun(infor.extra)
            });
        })

    }
}


class huoshanUploadFile {
    constructor(options) {
        this.files = []
    }
    /**
     * 上传文件
     *
     * @param {File} file - 要上传的文件
     * @param {Function} completeFun - 上传完成后的回调函数
     * @param {Function} errorFun - 上传错误回调函数
     */
    uploadFile(file, fileType, completeFun, errorFun) {
        service({
            url: HSUPLOAD_HOST + "/api/upload/tos/token",
        }).then(async res => {
            this.uploader = new TOS({
                // yourRegion 填写 Bucket 所在地域。以华北2（北京)为例，yourRegion 填写为 cn-beijing。
                region: res.data.data.regionId,
                // 填写 endpoint 名称。
                endpoint: res.data.data.endpoint,
                // 从 STS 服务获取的临时访问密钥（AccessKey ID 和 AccessKey Secret）。
                accessKeyId: res.data.data.accessKeyId,
                accessKeySecret: res.data.data.secretAccessKey,
                // 从 STS 服务获取的安全令牌（SecurityToken）。
                stsToken: res.data.data.sessionToken,
                // 填写 Bucket 名称。
                bucket: res.data.data.bucket,
            });
            let timestamp = new Date().getTime()
            let fileName = `${fileType}/${moment().format('YYYYMMDD')}/${md5(timestamp.toString())}.${getFileExtension(file)}`
            const result = await this.uploader.putObject({
                key: fileName,
                body: file,
            });
            if (result.statusCode == 200) {
                completeFun({
                    url: `${OSSURL}/${fileName}`,
                })
            } else {
                errorFun(result)
            }
        })

    }
}

/**
     * 上传文件
     *
     * @param {File} file - 要上传的文件
     * @param {Function} completeFun - 上传完成后的回调函数
     * @param {Function} progressFun - 上传进度回调函数
     * @param {Function} errorFun - 上传错误回调函数
     */

async function HS_upload(file, completeFun, errorFun, progressFun, isShortPlay) {
    let fileType = checkFileType(file)
    if (fileType === 'video') {
        return new huoshanUploadVideo().uploadFile(file, completeFun, progressFun, errorFun, isShortPlay)
    } else {
        return new huoshanUploadFile().uploadFile(file, fileType, completeFun, errorFun)
    }
}

function checkFileType(file) {
    if (file.type.startsWith('image/')) {
        return 'image'
    } else if (file.type.startsWith('video/')) {
        return 'video'
    } else if (file.type.startsWith('audio/')) {
        return 'audio'
    } else {
        return 'file'
    }
}

function getPath(path) {
    let index = path.indexOf(".");
    let obj = path.substring(index + 1, path.length);
    let index2 = obj.indexOf("/");
    let url = obj.substring(0, index2);
    return url;
}

export { HS_upload }